export const EmptyState = `
  <EmptyState
    heading="Empty State Reason" // String
    description='Lorem Ipsum' // String
    buttonAction={(e) => console.log('clicked button')} // Function
    buttonLabel="Add Project" // String
    icon={<IconMail size="sm" />} // React
    size={"md"} // String: md, lg
  />
`
